<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-md">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('mail.tagProject') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="loadForm">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="">
                <div class="col-12 ">
                    <h4>{{$t('mail.help_project_tag')}} </h4>
                </div>
                <div class="col-12 ">
                  <Select2
                      containerClass="form-group mb-5"
                      :name="`model_ids`"
                      :multiple="true"
                      selectClass="form-select-lg form-select-solid form-control-lg"
                      :isRequired="false"
                      :placeholderText="$t('mail.help_project_tag')"
                      v-model="formDataUpdate.model_ids"
                  >
                    <option v-for="(project, index) in projectsFormatted" :key="project.value" :value="project.value">
                      {{ project.name }}
                    </option>
                  </Select2>
                </div>
            </div>
          </div>  
          <div class="modal-footer mt-20">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="loadForm"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.send" size="7px 30px" :is-loading="isLoadingUpdate"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
  import {ref, defineEmits, defineProps, watch, computed, onMounted} from "vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";
  import TagInput from "@/components/TagifyInput.vue";
  import Select2 from "@/components/Select2.vue";
  

  const store = useStore()

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        uid: "",
        folder: "",
        model_ids: []
      }
    }
  })
  const emits = defineEmits(['load', 'edit'])

  const isLoadingUpdate = ref(false)
  const formDataUpdate = ref({
    uid: "",
    folder: "",
    model_ids: []
  })

  const projects = computed(() => store.getters['projects/getProjectsCollection'])
  const projectsFormatted = computed(() => {
    return projects.value.map(el => ({name: el.title, value: el.id}))
  })

  watch(() => props.form, (value) => {
    if(value) {
      formDataUpdate.value.uid = value.uid
      formDataUpdate.value.folder = value.folder
      formDataUpdate.value.model_ids = value.model_ids
    }
  }, { deep: true, immediate: true });

 

  function closeModal(){
    $('#'+props.id).modal('toggle')
    emits('edit', false)
  }

  function loadForm() {
    closeModal()
    resetForm() 
  }

  function resetForm() {
    formDataUpdate.value.uid = ''
    formDataUpdate.value.folder = ''
    formDataUpdate.value.model_ids = []
  }

  async function submitForm(){
    try {
      isLoadingUpdate.value = true;
      emits('edit', isLoadingUpdate.value)

      await store.dispatch('mails/tagMail', formDataUpdate.value).then((res) =>{
        emits('load');
        loadForm()
        window.toastr['success'](i18n.global.t('mail.update_successfully'))
      }).finally(() => {
        isLoadingUpdate.value = false;
        emits('edit', isLoadingUpdate.value)
      }) 
    } catch (error) {
    }
  }

</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }

  .border_style {
    border: 2px solid var(--bs-light)
  }

  .modal-body {
    max-height: 75vh !important;
  }
</style>